import { RegistrationProfileScreen } from "@/interactors/RegistrationProfileScreen.tsx";

export default function RegistrationProfile() {
  return <RegistrationProfileScreen />;
}
